var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDpoCreate = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M52.39 57.91H8.69a2.36 2.36 0 0 1-2.36-2.36v-43.7a2.36 2.36 0 0 1 2.36-2.36h43.7a2.36 2.36 0 0 1 2.36 2.36v43.7a2.36 2.36 0 0 1-2.36 2.36ZM8.69 11a.86.86 0 0 0-.86.86v43.7a.87.87 0 0 0 .86.86h43.7a.86.86 0 0 0 .86-.86V11.85a.85.85 0 0 0-.86-.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M35 62.32H4.22a3 3 0 0 1-3-3V28.93a.75.75 0 0 1 1.5 0v30.4a1.49 1.49 0 0 0 1.49 1.49H35a.75.75 0 0 1 0 1.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m33.47 22.93-1.22 9.42L41.06 31 62 10.33V10a9.34 9.34 0 0 0-8.14-7.57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M32.25 33.1a.73.73 0 0 1-.52-.21.76.76 0 0 1-.22-.64l1.22-9.41a.7.7 0 0 1 .21-.43L53.29 1.9a.72.72 0 0 1 .61-.21 10 10 0 0 1 8.8 8.17l.06.33a.77.77 0 0 1-.21.67l-21 20.66a.72.72 0 0 1-.41.2l-8.81 1.37Zm1.93-9.82-1.06 8.18 7.59-1.18 20.5-20.2a8.54 8.54 0 0 0-7.12-6.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M59.62 12.6 62 10.33V10a9.34 9.34 0 0 0-8.14-7.57l-2.52 2.46Z"
  })));
};
export default SvgIconDpoCreate;